import React from 'react';
import { User } from 'lucide-react';

export default function OrderDetailsSkeleton() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4 md:p-8">
      <div className="mx-auto">
        <div className="mb-6 h-6 w-48 bg-slate-300 rounded animate-pulse"></div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="flex items-center gap-3 bg-[rgb(29,78,216)] text-white px-6 py-3">
            <User size={18} />
            <span className="text-sm font-medium">Carregando Detalhes</span>
          </div>

          <div className="p-6">
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
              <div className="border-l-4 border-teal-500 pl-6">
                <div className="h-4 w-24 bg-slate-200 rounded mb-2 animate-pulse"></div>
                <div className="h-6 w-40 bg-slate-300 rounded animate-pulse"></div>
              </div>

              <div>
                <div className="h-4 w-32 bg-slate-200 rounded mb-2 animate-pulse"></div>
                <div className="h-7 w-36 bg-slate-300 rounded mb-3 animate-pulse"></div>
                <div className="h-4 w-20 bg-slate-200 rounded mb-2 animate-pulse"></div>
                <div className="h-6 w-32 bg-slate-300 rounded animate-pulse"></div>
              </div>

              <div>
                <div className="h-4 w-36 bg-slate-200 rounded mb-2 animate-pulse"></div>
                <div className="h-6 w-40 bg-slate-300 rounded mb-3 animate-pulse"></div>
                <div className="h-4 w-24 bg-slate-200 rounded mb-2 animate-pulse"></div>
                <div className="h-5 w-44 bg-slate-300 rounded animate-pulse"></div>
              </div>

              <div>
                <div className="h-4 w-28 bg-slate-200 rounded mb-2 animate-pulse"></div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-3 h-3 bg-teal-300 rounded-full animate-pulse"></div>
                  <div className="h-6 w-36 bg-slate-300 rounded animate-pulse"></div>
                </div>
                <div className="h-4 w-32 bg-slate-200 rounded animate-pulse"></div>
              </div>
            </div>
          </div>

          <div className="border-t border-slate-200 p-6 space-y-8">
            <div>
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
                <div className="h-7 w-48 bg-slate-300 rounded animate-pulse"></div>
                <div className="h-11 w-40 bg-slate-200 rounded-xl animate-pulse"></div>
              </div>

              <div className="bg-slate-50 rounded-xl p-6 mb-6">
                <div className="h-6 w-40 bg-slate-300 rounded mb-1 animate-pulse"></div>
                <div className="h-5 w-32 bg-slate-200 rounded mb-6 animate-pulse"></div>

                <div className="flex justify-between items-start mb-4">
                  {[1, 2, 3, 4, 5].map((item) => (
                    <div key={item} className="flex flex-col items-center flex-1">
                      <div className="w-8 h-8 bg-slate-300 rounded-full animate-pulse mb-3"></div>
                      <div className="h-3 w-20 bg-slate-200 rounded animate-pulse mb-2"></div>
                      <div className="h-3 w-24 bg-slate-200 rounded animate-pulse"></div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex gap-3 mb-6">
                <div className="w-5 h-5 bg-blue-200 rounded animate-pulse flex-shrink-0"></div>
                <div className="h-5 w-56 bg-blue-200 rounded animate-pulse"></div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <div className="h-4 w-20 bg-slate-200 rounded mb-2 animate-pulse"></div>
                  <div className="h-5 w-full bg-slate-300 rounded animate-pulse"></div>
                </div>

                <div>
                  <div className="h-4 w-40 bg-slate-200 rounded mb-2 animate-pulse"></div>
                  <div className="h-6 w-36 bg-slate-200 rounded animate-pulse"></div>
                </div>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="text-left py-4 px-4">
                        <div className="h-3 w-12 bg-slate-200 rounded animate-pulse"></div>
                      </th>
                      <th className="text-left py-4 px-4">
                        <div className="h-3 w-16 bg-slate-200 rounded animate-pulse"></div>
                      </th>
                      <th className="text-center py-4 px-4">
                        <div className="h-3 w-20 bg-slate-200 rounded animate-pulse mx-auto"></div>
                      </th>
                      <th className="text-center py-4 px-4">
                        <div className="h-3 w-32 bg-slate-200 rounded animate-pulse mx-auto"></div>
                      </th>
                      <th className="text-right py-4 px-4">
                        <div className="h-3 w-24 bg-slate-200 rounded animate-pulse ml-auto"></div>
                      </th>
                      <th className="text-right py-4 px-4">
                        <div className="h-3 w-20 bg-slate-200 rounded animate-pulse ml-auto"></div>
                      </th>
                      <th className="text-right py-4 px-4">
                        <div className="h-3 w-32 bg-slate-200 rounded animate-pulse ml-auto"></div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200">
                    {[1, 2, 3].map((item) => (
                      <tr key={item}>
                        <td className="py-4 px-4">
                          <div className="h-4 w-32 bg-slate-200 rounded animate-pulse"></div>
                        </td>
                        <td className="py-4 px-4">
                          <div className="h-4 w-48 bg-slate-200 rounded animate-pulse"></div>
                        </td>
                        <td className="py-4 px-4">
                          <div className="h-4 w-8 bg-slate-200 rounded animate-pulse mx-auto"></div>
                        </td>
                        <td className="py-4 px-4">
                          <div className="h-4 w-8 bg-slate-200 rounded animate-pulse mx-auto"></div>
                        </td>
                        <td className="py-4 px-4">
                          <div className="h-4 w-20 bg-slate-200 rounded animate-pulse ml-auto"></div>
                        </td>
                        <td className="py-4 px-4">
                          <div className="h-4 w-24 bg-slate-200 rounded animate-pulse ml-auto"></div>
                        </td>
                        <td className="py-4 px-4">
                          <div className="h-4 w-24 bg-slate-200 rounded animate-pulse ml-auto"></div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="flex justify-end pt-4 border-t border-slate-200">
                <div className="text-right">
                  <div className="h-4 w-16 bg-slate-200 rounded mb-2 animate-pulse ml-auto"></div>
                  <div className="h-8 w-32 bg-slate-300 rounded animate-pulse"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
